import React from 'react';
import {
  MimaText,
  MimaButton,
  MimaInput,
  PageLoader,
} from '../../components';
import styles from '../../assets/styles/Inventory/Checkout.module.scss';
import { Formik } from 'formik';
import { amountFormatter } from '../../utils/utils';
import { inventoryStore } from '../../stores';

const ProductDisplay = ({
  product, stockData, onStockClick, validationSchema, onSubmit, loading, Img1, Img2, Img3, mainImage, setMainImage, biz
}) => {
 const MimaLogo = "https://res.cloudinary.com/mima-business/image/upload/v1669813147/mima-logo_wzrulf.png"

  return (
    <>
      {loading ? <PageLoader title="while the product is populated"/> : (

          <div className={styles.main}>
            <div className={styles.business}>
              <img src={biz?.logoUrl} alt={`${biz.tradingName.split(' ').map(word => word.charAt(0).toUpperCase()).join('')} Logo`}/>
              {biz?.tradingName}
            </div>

            

            <div className={styles.product}>
              <div className={styles.product__images}>
                <div className={styles.product__images_main2}>
                  <img src={mainImage} alt="Product Image" />
                </div>
                <div className={styles.product__images_crumbs}>
                  <img
                    src={Img1}
                    alt="Product Image 1"
                    onClick={()=>{
                      setMainImage(Img1)
                    }}
                    className={mainImage === Img1 ? styles.product__images_crumbs__active : ""}
                  />

                  <img
                    src={Img2}
                    alt="Product Image 2"
                    onClick={()=>{
                      setMainImage(Img2)
                    }}
                    className={mainImage === Img2 ? styles.product__images_crumbs__active : ""}
                  />

                  <img
                    src={Img3}
                    alt="Product Image 3"
                    onClick={()=>{
                      setMainImage(Img3)
                    }}
                    className={mainImage === Img3 ? styles.product__images_crumbs__active : ""}
                  />
                </div>
              </div>
              <div className={styles.product__desc}>
              <MimaText variant="subtitleBold" color="var(--color-primary)">
                  {product?.name}
                </MimaText>

                <MimaText mb={1} mt={1}>
                  {product?.description}
                </MimaText>

                <MimaText variant="smallBold" mb={1}>Variation(s)</MimaText>

                <div className={styles.variations}>
                  {product?.stocks.map((stock, index) => {
                    return (
                      <div
                        key={index}
                        onClick={() => {onStockClick(stock);}}
                        className={
                          stock?._id === inventoryStore?.selectedStock?._id
                            ? styles.variations_selectedVariation
                            : styles.variations_variation
                        }
                      >
                        <div>
                          {`${stock.title || ''}
                          - ${stock?.variations?.map(
                            variant => `${variant.type}: ${variant.value}`
                          ) || ''} - ${amountFormatter(stock.currencyCode).format(stock.sellingPrice)}`}
                        </div>
                      </div>
                    )
                  })}
                </div>

                <Formik
                  initialValues={{
                    quantity: 0
                  }}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}>
                  {({
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched,
                  }) => (
                    <div>
                      <div style={{display: 'flex'}}>
                        <MimaInput
                          type="number"
                          labelTitle={`Quantity (${product?.unitOfMeasurement ? (product?.unitOfMeasurement) : ''})`}
                          min="1"
                          max={stockData?.quantity}
                          name="quantity"
                          value={values.quantity}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.quantity}
                          touched={touched.quantity}
                          width={18}
                          mr={2}
                        />

                        <MimaText labelTitle="Total Cost" mb={2} mt={1} variant="subtitleBold">
                          {amountFormatter(inventoryStore.selectedStock?.currencyCode).format(inventoryStore.selectedStock?.sellingPrice * values.quantity || 0)}
                        </MimaText>
                      </div>


                      <MimaButton
                        title="Checkout"
                        type="submit"
                        className={styles.form__checkoutBtn}
                        width={18}
                        loading={loading}
                        onClick={handleSubmit}
                      />
                    </div>
                  )}
                </Formik>
              </div>
            </div>
            <div className={styles.mima}>
              <p>Powered by</p> <img src={MimaLogo} className={styles.mima__logo} />
            </div>
          </div>

        )
      }
    </>
  )
}

export default ProductDisplay